<app-modal-shell [showClose]="false"
  [showFooter]="true">
  <span modalTitle>{{ 'siteActivation.title' | translate }}</span>
  <span modalDescription>{{ 'siteActivation.eyebrow' | translate }}</span>

  <main class="pending-activation"
    role="status"
    aria-live="polite">
    <img class="pending-activation__logo"
      src="./assets/images/logo.png"
      alt="Urakka.app" />
    <div class="pending-activation__copy">
      <p>{{ 'siteActivation.message' | translate }}</p>
    </div>
  </main>

  <div modalFooter>
    <ion-button fill="outline"
      [disabled]="loggingOut()"
      (click)="logout()">
      <ion-icon slot="start"
        name="log-out-outline"></ion-icon>
      {{ 'logout.title' | translate }}
    </ion-button>
  </div>
</app-modal-shell>
